'use strict';
import $ from 'jquery';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    send_error: 'Ocorreu um erro ao enviar. Tente novamente mais tarde.',
    sending: 'Enviando...'
  },
  en: {
    send_error: 'Ocorreu um erro ao enviar. Tente novamente mais tarde.',
    sending: 'Sending...'
  },
  es: {
    send_error: 'Ocorreu um erro ao enviar. Tente novamente mais tarde.',
    sending: 'Enviando...'
  },
}

const challenge4 = {
  settings: {
    $form: $('.js-send-story'),
    $invalidFeedback: $('.invalid-feedback'),
    $inputStory: $('textarea[name="lyric"]'),
    $inputPhotos: $('input[name="photo"]'),
    $submitButton: $('.js-submit-btn'),
    submitButtonText: ''
  },

  resetForm() {
    s.$inputStory.val('');
    s.$inputPhotos.val('');
  },

  sendStory() {
    s.$form.on('submit', function (e) {
      e.preventDefault();

      s.$submitButton.prop('disabled', true).html(tr[lang].sending);
      s.$invalidFeedback.hide();

      const formData = new FormData();
      formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
      formData.append('lyric', s.$inputStory.val());
      if (s.$inputPhotos[0].files.length > 0) {
        formData.append('photo', s.$inputPhotos[0].files[0]);
      }
      formData.append('stage', $('input[name="stage"]').val());

      $.ajax({
        type: 'POST',
        url: s.$form[0].action,
        data: formData,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (response) {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              title: response.success,
            }).then(() => {
              _this.resetForm();
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: response.error,
            }).then(() => {
              _this.resetForm();
            });
          }
        },
        error: function (response) {
          if (response.status === 422) {
            // Clear previous errors
            s.$invalidFeedback.html('');

            // Loop through each error field and display the associated messages
            $.each(response.responseJSON.errors, function (field, messages) {
              const $inputElement = $(`input[name="${field}"], textarea[name="${field}"]`);

              // Ensure the element exists and has a feedback element to append the messages
              if ($inputElement.length) {
                const $feedbackElement = $inputElement.next(s.$invalidFeedback);

                if ($feedbackElement.length) {
                  // Loop through each error message and append it
                  $.each(messages, function (index, message) {
                    $feedbackElement.append(`<div>${message}</div>`);
                  });
                }
              }
            });

            s.$invalidFeedback.show();
          } else {
            // Handle other types of errors (e.g., 500 Internal Server Error)
            Swal.fire({
              icon: 'error',
              title: tr[lang].send_error,
            });
          }
        },
        complete: function () {
          s.$submitButton.prop('disabled', false).text(s.submitButtonText);
        },
      });
    });
  },
};

const _this = challenge4,
  s = _this.settings;

s.submitButtonText = s.$submitButton.text();

export default challenge4;